import React from 'react';
import { Neo, Views } from '@singularsystems/neo-react';
import SystemMaintenanceVM from './SystemMaintenanceVM';
import { observer } from 'mobx-react';
import { ModalUtils } from '@singularsystems/neo-core';

@observer
export default class SystemMaintenanceView extends Views.ViewBase<SystemMaintenanceVM> {

    constructor(props: unknown) {
        super("System Maintenance", SystemMaintenanceVM, props);
    }

    public render() {
        return (
            <div>
                <Neo.Card title="System Maintenance">

                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <Neo.Button className="me-2" onClick={() => this.createAccruals()} disabled={SystemMaintenanceVM.cachedState.accrualsCreated}>
                                        Generate accruals
                                    </Neo.Button>
                                </td>
                                <td>
                                    Creates accruals for investments that don't have any accruals. This should only be necessary after new data has been imported.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Neo.Button className="me-2" onClick={() => this.regenerateAccruals()} disabled={SystemMaintenanceVM.cachedState.accrualsCreated}>
                                        Regenerate all accruals
                                    </Neo.Button>
                                </td>
                                <td>
                                    Re-creates accruals for all investments. This will override the accruals for all investments. Use with caution.
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Neo.Button className="me-2" onClick={() => this.viewModel.extendAccruals()} disabled={SystemMaintenanceVM.cachedState.accrualsCreated}>
                                        Extend accruals
                                    </Neo.Button>
                                </td>
                                <td>
                                    Extends accruals to the current projection date. Can be used when the projection period has changed.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Neo.Card>

                <Neo.Card title="File Transfer">
                    {this.viewModel.tempFileCount === null &&
                        <Neo.Button onClick={() => this.viewModel.getTempFileCount()}>
                            Check temp files
                        </Neo.Button>}

                    {this.viewModel.tempFileCount !== null && this.viewModel.tempFileCount > 0 &&
                        <table>
                            <tr>
                                <td>
                                    <Neo.Button className="me-2" onClick={() => this.viewModel.transferFiles()} disabled={SystemMaintenanceVM.cachedState.filesTransferred}>
                                        Transfer {this.viewModel.tempFileCount} files
                                    </Neo.Button>
                                </td>
                                <td>
                                    Transfers temporary files from data take-on to blob storage. This should only be necessary after new data has been imported.
                                </td>
                            </tr>
                        </table>}
                </Neo.Card>
            </div>
        );
    }

    private createAccruals() {
        this.viewModel.createAccruals(false);
    }

    private regenerateAccruals() {
        ModalUtils.showYesNoDismissible("Regenerate accruals", "This will regenerate accruals for all investments, active or inactive. Are you sure you want to continue?",
            () => this.viewModel.createAccruals(true))
    }
}